import CustomerPage from "./CustomerContainer";

export default CustomerPage;
